import { motion } from "framer-motion";
import { comicFrames } from "../data/comicFrames";

const ComicStrip = () => {
	return (
		<div className='space-y-8'>
			<h2 className='text-3xl font-black text-trump-yellow text-center mb-8'>
				THE LEGEND OF $TRUMP
			</h2>
			<div className='grid md:grid-cols-3 gap-8'>
				{comicFrames.map((frame, index) => (
					<motion.div
						key={frame.id}
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ delay: index * 0.2 }}
						className='relative group'>
						{/* Frame Border */}
						<div className='absolute inset-0 bg-gradient-to-br from-trump-yellow via-trump-red to-trump-blue opacity-20 rounded-xl transform group-hover:scale-105 transition-transform duration-300' />

						{/* Comic Frame */}
						<div className='relative bg-black/40 p-4 rounded-xl border-4 border-white/10 group-hover:border-white/30 transition-colors'>
							<div className='aspect-[4/3] mb-4 overflow-hidden rounded-lg'>
								<img
									src={frame.image}
									alt={frame.text}
									className='w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500'
								/>
							</div>
							<div className='relative'>
								{/* Speech Bubble */}
								<div className='bg-white rounded-2xl p-4 shadow-xl'>
									<div
										className='absolute w-4 h-4 bg-white transform rotate-45'
										style={{
											[frame.position === "left" ? "left" : "right"]: "-8px",
											top: "50%",
											marginTop: "-8px",
										}}
									/>
									<p className='text-black font-comic text-lg text-center'>
										{frame.text}
									</p>
								</div>
							</div>
						</div>
					</motion.div>
				))}
			</div>
		</div>
	);
};

export default ComicStrip;
